import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import SignupPage from '@/views/SignupPage.vue'
import Catalogue from '@/views/Catalogue.vue'
import AddStore from '@/views/AddStore.vue'
import Settings from '@/views/Settings.vue'
import Dashboard from'@/views/Dashboard.vue'
import Orders from '@/views/Orders.vue'
import Customers from  '@/views/Customers.vue'
/*global myBaseURL*/

import axios from 'axios';

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Home
  },
  
  {
    path: '/signup',
    name: 'SignupPage',
    component: SignupPage
  },

  {
    path: '/:store_slug/dashboard/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
      role : 'merchant'
    }
  },

  {
    path: '/:store_slug/orders/',
    name: 'Orders',
    component: Orders,
    meta: {
      requiresAuth: true,
      role : 'merchant'
    }
  },

  {
    path: '/:store_slug/customers/',
    name: 'Customers',
    component: Customers,
    meta: {
      requiresAuth: true,
      role : 'merchant'
    }
  },

  {
    path: '/:store_slug/catalogue/',
    name: 'Catalogue',
    component: Catalogue,
    meta: {
      requiresAuth: true,
      role : 'merchant'
    }
  },
  {
    path: '/addStore',
    name: 'AddStore',
    component: AddStore,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/:store_slug/settings/',
    name: 'Settings',
    component: Settings,
    meta: {
      requiresAuth: true
    }
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
    var arr = ['/','/login','/signup']
    var curPath = to.path;
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    
    var flag = 0;
    axios.request({
        url: '/checkMerchantToken',
        method: 'GET',
        baseURL: myBaseURL,
        headers: {
            'Authorization': 'Bearer '+ window.localStorage.access_token
        }
    }).then(response => {
        console.log(response.data);
        if(response.data.token)
        {
          flag = 1;
        }
        else
        {
          flag = 0;
        }

        if(requiresAuth && flag == 1)
        {
          next()
        }
        else if(requiresAuth && flag != 1)
        {
          next('login')
        }
        else if(!requiresAuth && flag == 1 && arr.indexOf(curPath) > -1)
        {
          next('addStore')
        }
        else if(!requiresAuth)
        {
          next()
        }
    }).catch(e => {
        console.log(e);
        console.log('Fail Data')
        flag = 0;
        if(requiresAuth && flag != 1)
        {
          next('login')
        }
        else
        {
          next()
        }
    });
})

export default router
